var _defs, _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _path2, _circle7, _path3, _circle8, _circle9, _circle10, _path4, _path5, _path6, _circle11, _path7, _circle12, _circle13, _path8, _circle14, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawTeamGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 776.32 488.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#2f2e41;}.cls-3{fill:#9e616a;}.cls-4{fill:#ffb6b6;}.cls-5{fill:#ffb8b8;}.cls-6{fill:#6c63ff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 113.44,
    cy: 373.97,
    r: 113.44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.45,
    cy: 333.46,
    r: 45.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.49,113.64a111.47,111.47,0,1,1,0-.59C227.5,113.25,227.5,113.45,227.49,113.64Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 382.63,
    cy: 373.97,
    r: 113.44
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 382.3,
    cy: 113.44,
    r: 113.44
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 658.78,
    cy: 113.44,
    r: 113.44
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 662.88,
    cy: 373.97,
    r: 113.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.48,76.54c4.69-15,15.35-28.66,30.11-33.72s36.35,2.65,47.44,13.7c20.29,20.22,25.24,89.68,11.3,111.63-2.77-.15-12.34-.26-15.14-.36l-4-13.23v13.1q-6.7-.21-13.52-.29A58.82,58.82,0,0,1,59.63,110C59.26,95.44,59.63,82.43,61.48,76.54Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 112.37,
    cy: 93.75,
    r: 32.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.47,65.36,121.7,46.72h0a46.8,46.8,0,0,1,27.4,38.76L150,96.6l-15.59-4-1.71-14.21-2.65,13.1-7.19-1.83L123,67.63l-7.2,22.05L90.07,83.77Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 351.48,
    cy: 315.39,
    r: 16.02
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 377.1,
    cy: 351.69,
    r: 40.57
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 380.46,
    cy: 359.28,
    r: 32.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.85,325.68a37.77,37.77,0,0,0-57.42,33c16.8,4.21,34.45,7.44,52.37,1L402,349.29l2.49,10.36c5.46,2.23,10.93,4.12,16.4,0A38.54,38.54,0,0,0,402.85,325.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.57,271.91c-11.08-5.08-25-2.69-34.2,5.27s-13.6,20.92-11.82,33c1.82,12.3,9.29,22.89,16.18,33.23s13.62,21.68,13.61,34.11a33.81,33.81,0,0,1-33.74,33.79c10.51,4.52,21.47,9.14,32.9,8.6s23.4-7.88,25.27-19.17c1.34-8.13-2.65-16.06-6-23.6a166.92,166.92,0,0,1-11.67-38.41c-1.11-6.31-1.83-12.95.23-19A22.33,22.33,0,0,1,349.53,305l3.78-3.4C355,289.56,347.64,277,336.57,271.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M612.48,69.07a106.55,106.55,0,0,1-7.6,24.27c-20,42.33,37,28.53,57.34,28.53,22.27,0,43.57,11.71,40.32-40.31-1.39-22.23-18-40.32-40.32-40.32C643.2,41.24,616.46,49.69,612.48,69.07Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 658.88,
    cy: 89.1,
    r: 32.76
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M636.64,55.71a37.52,37.52,0,0,1,57.05,32.75c-16.69,4.19-34.23,7.4-52,1l-4.21-10.29L635,89.47c-5.42,2.21-10.85,4.09-16.29,0A38.3,38.3,0,0,1,636.64,55.71Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 114.47,
    cy: 344.23,
    r: 40.41,
    transform: "translate(-237.01 434.01) rotate(-85.93)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 386.92,
    cy: 88.02,
    r: 36.99
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bd502a69-4a38-4003-a7a1-fa248c8198be-204",
    className: "cls-2",
    d: "M419.49,63.58s9.63-18.41-11.55-20.08c0,0-18.07-16.39-36.48-3,0,0-10,0-15.53,11.37,0,0-7.9-3-9.64,5,0,0-5.78,16.74,0,31.8s7.7,16.74,7.7,16.74-4.05-18.69,19.06-20.37,44.33-16.15,46.25,2.26,4.05,10.09,4.05,10.09S441.65,71.12,419.49,63.58Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 659.75,
    cy: 351.81,
    r: 36.21
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.23,448.51A113.39,113.39,0,0,1,39.52,460l9.73-27.15a29.2,29.2,0,0,1,24.8-17l6.19-.38L95,402.69s39.77-1.42,39.18-2.1l24.09,14.49,0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M468,449.87a113.41,113.41,0,0,1-158.72,11.47L319,434.19a29.2,29.2,0,0,1,24.8-17l6.19-.38,14.76-12.73s39.77-1.42,39.18-2.1L428,416.44l0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M748,449.87a113.41,113.41,0,0,1-158.72,11.47L599,434.19a29.2,29.2,0,0,1,24.8-17l6.19-.38,14.76-12.73s39.77-1.42,39.18-2.1L708,416.44l0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.23,188.51A113.39,113.39,0,0,1,39.52,200l9.73-27.15a29.2,29.2,0,0,1,24.8-17l6.19-.38L95,142.69s39.77-1.42,39.18-2.1l24.09,14.49,0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M467,188.87a113.41,113.41,0,0,1-158.72,11.47L318,173.19a29.2,29.2,0,0,1,24.8-17l6.19-.38,14.76-12.73s39.77-1.42,39.18-2.1L427,155.44l0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747,188.87a113.41,113.41,0,0,1-158.72,11.47L598,173.19a29.2,29.2,0,0,1,24.8-17l6.19-.38,14.76-12.73s39.77-1.42,39.18-2.1L707,155.44l0-.1,9.47.58a29.16,29.16,0,0,1,24.8,17Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M697.94,329.35a46.69,46.69,0,0,0-19.55-26.6c-7.6-4.86-17.09-7.34-25.7-4.77s-15.75,11-15.18,20.16c-3.11-1.06-6.65.35-8.92,2.75s-3.5,5.64-4.38,8.86a56.35,56.35,0,0,0,.53,31.19l-.17,1.45c4.2-.69,7.39-4.3,9.37-8.14s3.12-8.1,5.27-11.85,5.72-7.09,10-7.2l-.37,6.5,11-5.66-2.61,6.25,9.59-4q-.54,3-1.07,6c3.17-7.22,13-10.39,19.64-6.35,3.88,2.34,6.42,6.52,7.76,10.91s1.6,9,1.85,13.61A47.65,47.65,0,0,0,697.94,329.35Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.11,330.06q.42-4.53.39-9.08a42.8,42.8,0,0,0-3.23-17.49,26.82,26.82,0,0,0-14.06-13.59,25.69,25.69,0,0,0-19.25,0c-5.57-3.51-11.75-6.3-18.27-6.65s-13.41,2.07-17.43,7.4a28.23,28.23,0,0,1-3,3.95c-3.23,3-8.14,2.56-12.43,1.95l5.78,4.95-7,1.82,8.15,4.95C68.84,313,65.25,323.36,66.2,332.75c.9,8.89,5.19,17,10.32,24.25,2-4.32,1.61-9.49,1.57-14.36a34,34,0,0,1,.29-4.72c17.34,4.16,35.47,6.83,53.84.23l3.69-9,1.55.16,2.14,8.88c4.84,2,9.7,3.71,14.55,1.89.24,1.37.38,2.77.49,4.11.42-1.61.78-3.23,1.11-4.85a14.63,14.63,0,0,0,1.83-1.18A39.65,39.65,0,0,0,157.11,330.06Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTeamGroup);
export default __webpack_public_path__ + "static/media/undraw_team_group.f3c7fd52c43a0a0713a4481213355068.svg";
export { ForwardRef as ReactComponent };